module.exports = __webpack_public_path__ + "static/media/bg-circle-check.854340c2.svg";